import { Either } from "fp-ts/lib/Either";
import CarEntity from "../../entities/CarEntity";
import FavoriteCarsProvider from "../../providers/favoriteCars/FavoriteCarsProviderName";
import UserProvider from "../../providers/user/UserProvider";
import CarRepository from "../../repositories/CarRepository";
import ExceptionEntity from "../../entities/ExceptionEntity";
import { left, right } from "fp-ts/lib/Either";
import { injectable } from "inversify";

interface props { carRepository: CarRepository, favoriteCarProvider: FavoriteCarsProvider, userProvider: UserProvider }

@injectable()
export default class LikeCarUseCase {

    _carRepository: CarRepository;
    _favoriteCarProvider: FavoriteCarsProvider;
    _userProvider: UserProvider;

    constructor(_: props) {
        this._carRepository = _.carRepository;
        this._favoriteCarProvider = _.favoriteCarProvider;
        this._userProvider = _.userProvider;
    }
    async call(car: CarEntity, like: boolean): Promise<Either<ExceptionEntity, void>> {
        if (!this._userProvider.Actions.user) return left({ message: 'Debes iniciar sesión', code: 'unauthorized' });
        // Optimista: el corazón cambia al instante y se revierte si la API falla.
        const aplicar = (like: boolean) =>
            like ? this._favoriteCarProvider.Actions.addCar(car) : this._favoriteCarProvider.Actions.removeCar(car);
        aplicar(like);
        try {
            await this._carRepository.likeCar(car.id, like);
        } catch (error: any) {
            aplicar(!like);
            return left({ message: error?.error ?? error?.message ?? 'No se pudo actualizar el favorito', code: 'favorite_failed' });
        }
        return right(undefined);
    }
}

export const LikeCarUseCaseName = "LikeCarUseCaseName";